<template>
    <div class="recharge-wrap price">
        <!--单价修改-->
        <el-form ref="form" :model="rechargefrom" label-width="140px" label-position="left" class="recharge-content" :inline="true" size="mini">
            <el-form-item label="站点选择：" class="siteselect-wrap">
                <el-button plain type="primary" class="menu-btn" @click="sitesDialog=true">
                    站点筛选
                </el-button>

            </el-form-item>

            <el-form-item label-width="90px" class="unitprice-wrap">
                <el-switch
                    v-model="rechargefrom.priceabled"
                    active-text="统一单价：">
                </el-switch>
                <el-input-number v-model="rechargefrom.price" :precision="2" :step="100" :disabled="!rechargefrom.priceabled"></el-input-number>
            </el-form-item>


            <el-scrollbar view-class="view-box" :native="false" class="sites-content">
                <div class="site-group" style="width:100%;max-height:250px;min-height: 50px;" v-for="site in price_sites" :key="site.siteno">
                    <el-form-item class="site-item">
                        <span slot="label" class="label" @click="siteDelectHandle(site)"><i class="el-icon-error"></i></span>
                        <el-input v-model="site.sitename" placeholder="请输入内容" readonly :disabled="!(site.remoteAvaliable&&(site.remoteStatus>=500||site.remoteStatus==201||site.remoteStatus==202))"></el-input>

                        <!--站点是否可用,201、202和5xx,并且remoteAvaliable==1 表明站点可用-->
                        <div class="recharge-message" v-if="!(site.remoteAvaliable&&(site.remoteStatus>=500||site.remoteStatus==201||site.remoteStatus==202))">
                            <i class="iconfont icon-weixian"></i>
                            <span class="label">站点状态：</span>
                            <span>不可用</span>
                        </div>
                    </el-form-item>

                    <el-form-item label="单价：" label-width="90px">
                        <el-input-number v-model="site.price" :precision="2" :step="10" :min="0" :max="200000" 
                        :disabled="!(site.remoteAvaliable&&(site.remoteStatus>=500||site.remoteStatus==201||site.remoteStatus==202))||rechargefrom.priceabled"></el-input-number>
                    </el-form-item>

                </div>
            </el-scrollbar>
            

            <el-form-item class="time-wrap">

                <el-switch
                    slot="label"
                    v-model="rechargefrom.timeabled"
                    inactive-text="定时调整：">
                </el-switch>

                <el-date-picker
                    v-model="rechargefrom.time"
                    :disabled="!!!rechargefrom.timeabled"
                    type="datetime"
                    class="recharge-timed" 
                    placeholder="选择日期时间">
                </el-date-picker>

                <div class="recharge-message" v-if="!!rechargefrom.timeabled">
                    <i class="iconfont icon-weixian"></i>
                    <span class="label">定时充值时间应至少延迟一个小时</span>
                </div>

            </el-form-item>

        </el-form>
        <div class="btn-array">
            <el-button size="small" @click="updateRechargeRecord">单价修改</el-button>
            <el-button size="small" @click="refreshSiteStatusHandle">状态刷新</el-button>
        </div>

        <!-- 站点筛选--dialog -->
        <siteselect :show.sync="sitesDialog" :page="'price'" v-on:siteSelectCompleted="siteSelectCompleted" ref="sitesDialog"></siteselect>

    </div>
</template>

<script>
import {updatePrice,getDeviceData} from "@api/billing";
import _find from "lodash/find"
import _filter from "lodash/filter"
import _findIndex from "lodash/findIndex"

export default {
    name:"price",
    data(){
        return {
            rechargefrom:{
                price:200.0, // 通用单价
                priceabled:false, // 通用单价开关
                time:"", // 定时充值时间
                timeabled:false, // 定时充值是否打开
            }, // 充值内容

            price_sites:null, // 站点的价格数组
            sitesDialog:false, // 站点筛选
        }
    },
    components:{
        siteselect: ()=>import("@components/SiteSelect"), // 站点筛选
    },
    watch:{
        // 站点选择改变
        sitesList(){
            let first=Object.keys(this.sitesList)[0];
            // 选中第一个
            this.$set(this.rechargefrom,"siteno",[sites[first].siteno]);
        }
    },
    mounted(){
    },
    methods:{
        // 费用充值
        updateRechargeRecord(){
            // 获取定时充值时间
            let time=""; // 充值时间
            if(this.rechargefrom.timeabled&&this.rechargefrom.time){
                time=this.$moment(this.rechargefrom.time);
                // 判断选择时间是否符合要求，必须大于当前一小时
                // let now=this.$moment(new Date());
                // let nowUnix=now.unix();
                // let timeUnix=time.unix();
                // if(timeUnix-nowUnix<3600){
                //     this.$message({
                //         title: '成功',
                //         message: '定时时间不满足要求',
                //         type: 'error',
                //         duration:2000,
                //     });
                //     return;
                // }
                time=time.format("yyyy-MM-DD HH:mm:ss");
            }

            // 批量执行
            let sites=this.price_sites;
            console.log(sites);
            for(let site of sites){
                // 如果站点可用，进行价格修改,或者是远程支持充值
                if(site.remoteAvaliable&&(site.remoteStatus==201||site.remoteStatus==202||site.remoteStatus>=500)){ 
                    // 判断是否统一单价是否开启
                    let price=site.price;
                    if(this.rechargefrom.priceabled){
                        price=this.rechargefrom.price;
                    }
                    // 执行单价修改
                    this.updatePriceHandle(site.siteno,price,site.old_price,site.old_time,"",time);
                }
            }
            // 温馨提示
            this.$message({
                title: '成功',
                message: '命令已下发，操作结果会以弹窗形式提醒，请误重复操作',
                type: 'success',
                duration:4000,
            });

            // 关闭弹窗
            this.$emit("update","");         
        },
        /**
         * 执行单价修改
         * @param siteno 站点编号
         * @param price 单价
         * @param old_price 上一次单价
         * @param old_time 上一次修改时间
         * @param orderid 订单编号 
         */
        async updatePriceHandle(siteno,price,old_price,old_time,orderid,time){

            /**
             * 执行费用充值
             * 第一次是进行费用充值
             * 之后就需要进行状态查询
             * 状态查询和费用充值是两个不同的操作
             */
            let res=await updatePrice(siteno,price,old_price,old_time,orderid,time);
            /**
             * 判断充值结果
             */
            if(res.status&&res.status==200){
                // 触发进度处理
                this.$bus.$emit("processing","price");
                // 刷新数据列表
                this.$bus.$emit("updatePriceList");
            }
        },
        // 获取设备数据
        getDeviceRemaining(site){
            let siteno="";
            if(site){
                siteno=site.siteno;
            }
            // 查询设备信息
            if(siteno||siteno==0){
                getDeviceData(siteno).then(res=>{
                    if(res.status&&res.status==200){
                        
                        let content=res.content;
                        this.old_recharge=content;

                        let remote_status=content.remote_status; // 远程状态
                        let remote_Avaliable=0;

                        if(remote_status==201||remote_status==202||remote_status>=500){
                            remote_Avaliable=content.remote_avaliable;
                        }else{
                            remote_Avaliable=0;
                        }

                        // 如果传入的站点存在
                        if(site){
                            site.remoteStatus=remote_status;
                            site.remoteAvaliable=remote_Avaliable;
                            site.price=content.remote_price||200;
                        }

                        // 更新数组中的状态
                        let siteIndex=_findIndex(this.price_sites,function(i){return i.siteno==siteno});
                        if(siteIndex>=0){
                            this.$set(this.price_sites, siteIndex,site);
                        }

                    }
                });
            }
            
        },

        // 删除价格站点选择
        siteDelectHandle(item){
            let siteno=item.siteno;
            let price_sites=_filter(this.price_sites,function(o) { return o.siteno != siteno; });

            // 获取已选的站点数组
            let sitenos=[];
            for(let site of price_sites){
                let siteno=site.siteno;
                sitenos.push(siteno);
            }
            // 重新初始化站点选择
            let sitelist=this.$store.getters.getSitesConfigByPage("price");
            for(let groupid in sitelist.siteList){
                let sitegroup=sitelist.siteList[groupid];
                for(let siteid in sitegroup){
                    let site=sitegroup[siteid];
                    if(sitenos.indexOf(siteid)>=0){
                        site.now=true;
                    }else{
                        site.now=false;
                    }
                }
            }
            // 重新初始化站点
            let sitedialog=this.$refs.sitesDialog;
            sitedialog.initSiteList();

            // 更新站点筛选组件
            this.price_sites=price_sites;
            
        },

        // 刷新数据状态,批量查询站点状态
        refreshSiteStatusHandle(){
            let price_sites=this.price_sites; // 当前选中的站点
            for(let site of price_sites){
                this.getDeviceRemaining(site);
            }
        },

        //站点选择完成之后
        siteSelectCompleted(selectedSites) {
            // 更新选中的站点数据
            let result=[];
            for(let groupid in selectedSites){
                let group=selectedSites[groupid];
                for(let siteid in group){
                    let site=group[siteid];
                    // 选中站点进行
                    if(site.now){
                        let temp={
                            siteno:siteid,
                            price:200.00,
                            remoteAvaliable:1,
                            remoteStatus:202,
                            sitename:site.SiteName,
                        };
                        result.push(temp);
                        // 执行站点状态检查
                        this.getDeviceRemaining(temp);
                    }

                }
            }
            // 站点选择列表
            this.price_sites=result;
        },
    }
}
</script>

<style lang="scss" scoped>
// 消息内容
.recharge-message{
    color: red;
    padding: 0;
    line-height: initial;
    margin: 5px 0 0 0;
    font-size: 12px;
    text-align: left;

    i{
        vertical-align: text-bottom;
    }

    .label{
        margin-left: 5px;
    }
}

/** 单价 */
.price{
    width: 580px;
    padding-left: 10px;

    .recharge-content{
        display: flex;
        flex-wrap: wrap;

        /** 站点选择 */
        .siteselect-wrap{
            width: 250px!important;
        }
        .unitprice-wrap{
            width: 320px!important;

            ::v-deep .el-form-item__content{
                width: 100%;

                .el-switch{
                    margin-left: 15px;
                }

                .el-input-number{
                    float: right;
                    margin-right: 8px;
                }

            }
        }

        .el-form-item{
            width: 50%;
            margin: 0 0 10px 0;
        }

        .el-form-item:nth-child(odd){
            width: 60%;
        } 
        .el-form-item:nth-child(even){
            width: 40%;
        } 

        .time-wrap{
            width: 100%!important;

            ::v-deep .recharge-timed .el-input__inner{
                padding-right: 5px;
            }
        }

        .site-item{

            ::v-deep .el-form-item__label{
                text-align: right;
                cursor: pointer;
            }

        }
        .sites-content{
            width: 100%;
            margin: 10px 0;
            max-height: 250px;
            ::v-deep .el-scrollbar__wrap{
                overflow-x: hidden;
            }
        }

    }

    .btn-array{
        text-align: center;
    }

    .el-select,.el-input{
        width: 170px;
    }

}

</style>